/* eslint-disable no-restricted-globals */
import { cloneDeep } from "lodash";
import moment from "moment";
import React from "react";
import { BiTrash } from "react-icons/bi";
import { FaDotCircle, FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import AppButton from "../../common/AppButton";
import IconButton from "../../common/IconButton";
import api from "../../config/api";
import useJob from "../../hooks/useJob";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const JobResults = ({ list }) => {
  const job = useJob();
  const queryClient = useQueryClient();

  const navigate = useNavigate();
  const handleDelete = async (job) => {
    if (confirm("Are you sure want to delete the job ?") === false)
      return false;
    const res = await api.put("jobs", { _id: job._id, isDeleted: true });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["jobs"]);

    toast.success("Job has been successfully deleted");
  };

  const handleView = (data) => {
    const path = job.findPath({ job: data });
    delete data.status;
    navigate(path, {
      state: {
        data: cloneDeep({ ...data, organization: data.organization._id }),
      },
    });
  };

  return (
    <div>
      <table className="table table-default">
        <thead>
          <tr>
            <th>Job ID</th>
            <th>Client</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {list?.map((i) => {
            const isInvoiceCreated = i.invoiceCreated;

            return (
              <tr key={i._id}>
                <td>{i.jobId}</td>
                <td>{i.organization?.name}</td>
                <td>{moment(i.jobStartDate).format("DD/MM/YYYY")}</td>
                <td>{moment(i.jobEndDate).format("DD/MM/YYYY")}</td>
                <td>
                  <div
                    className="side-button"
                    style={{
                      width: 70,
                      borderWidth: 1,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {!isInvoiceCreated && (
                      <IconButton icon={<FaDotCircle color="tomato" />} />
                    )}
                    <AppButton
                      onClick={() => handleView(i)}
                      tooltip="More Details"
                      className="text-primary"
                      leftIcon={<FaEye />}
                    />

                    <AppButton
                      onClick={() => handleDelete(i)}
                      tooltip="Delete Job"
                      className="text-primary"
                      leftIcon={<BiTrash />}
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default JobResults;
